import React, { FC } from 'react';

import {
  Button,
  Menu,
  MenuButton,
  MenuItemOption,
  MenuList,
  MenuOptionGroup,
} from '@chakra-ui/react';
import { MdFilterList } from 'react-icons/md';

import { useManufacturers } from 'hooks/useManufacturers';

type Props = {
  /** The selected manufacturer's id, or undefined for all. */
  value?: string;
  onChange: (manufacturerId?: string) => void;
};

/**
 * The SKU's page "Filter" button (ClickUp 86bceudwp). Manufacturer is its
 * first filter: pick one to list only its SKUs, or "All manufacturers".
 */
export const ManufacturerFilter: FC<Props> = ({ value, onChange }) => {
  const { data: manufacturers = [] } = useManufacturers();
  const selected = manufacturers.find((m) => m._id === value);

  return (
    <Menu closeOnSelect>
      <MenuButton
        as={Button}
        variant={selected ? 'solid' : 'outline'}
        leftIcon={<MdFilterList size="20px" />}
        minW="180px">
        {selected ? `Manufacturer: ${selected.name}` : 'Filter'}
      </MenuButton>
      <MenuList maxH="320px" overflowY="auto" zIndex={10}>
        <MenuOptionGroup
          title="Manufacturer"
          type="radio"
          value={value ?? ''}
          onChange={(next) => onChange((next as string) || undefined)}>
          <MenuItemOption value="">All manufacturers</MenuItemOption>
          {manufacturers.map((m) => (
            <MenuItemOption key={m._id} value={m._id}>
              {m.name}
            </MenuItemOption>
          ))}
        </MenuOptionGroup>
      </MenuList>
    </Menu>
  );
};
